var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "columns" }, [
      _c("div", { staticClass: "column is-12 is-gapless is-multiline" }, [
        _vm._m(0),
        _c("div", { staticClass: "columns" }, [
          _c("label", { staticClass: "column is-3" }, [_vm._v("ProjectID : ")]),
          _c("div", { staticClass: "column is-9" }, [
            _vm._v(_vm._s(_vm.ProjectDetail.projectID))
          ])
        ]),
        _c("div", { staticClass: "columns" }, [
          _c("label", { staticClass: "column is-3" }, [
            _vm._v("Project Name : ")
          ]),
          _c("div", { staticClass: "column is-9" }, [
            _vm._v(_vm._s(_vm.ProjectDetail.projectName))
          ])
        ]),
        _c("div", { staticClass: "columns" }, [
          _c("label", { staticClass: "column is-3" }, [
            _vm._v("Partnumber : ")
          ]),
          _c("div", { staticClass: "column is-9" }, [
            _vm._v(_vm._s(_vm.ProjectDetail.partNumber))
          ])
        ]),
        _c("div", { staticClass: "columns" }, [
          _c("label", { staticClass: "column is-3" }, [_vm._v("Partname : ")]),
          _c("div", { staticClass: "column is-9" }, [
            _vm._v(_vm._s(_vm.ProjectDetail.partName))
          ])
        ]),
        _c("div", { staticClass: "columns" }, [
          _c("label", { staticClass: "column is-3" }, [
            _vm._v("Project Date : ")
          ]),
          _c("div", { staticClass: "column is-9" }, [
            _vm._v(_vm._s(_vm.ProjectDetail.projectDate))
          ])
        ]),
        _c("div", { staticClass: "columns" }, [
          _c("label", { staticClass: "column is-3" }, [
            _vm._v("Type Of Product : ")
          ]),
          _c("div", { staticClass: "column is-9" }, [
            _vm._v(_vm._s(_vm.ProjectDetail.typeOfProduct))
          ])
        ]),
        _c("div", { staticClass: "columns" }, [
          _c("label", { staticClass: "column is-3" }, [_vm._v("Material : ")]),
          _c("div", { staticClass: "column is-9" }, [
            _vm._v(_vm._s(_vm.ProjectDetail.material))
          ])
        ]),
        _c("div", { staticClass: "columns" }, [
          _c("label", { staticClass: "column is-3" }, [_vm._v("Hardening : ")]),
          _c("div", { staticClass: "column is-9" }, [
            _vm._v(_vm._s(_vm.ProjectDetail.hardening))
          ])
        ]),
        _c("div", { staticClass: "columns" }, [
          _c("label", { staticClass: "column is-3" }, [_vm._v("Plating : ")]),
          _c("div", { staticClass: "column is-9" }, [
            _vm._v(_vm._s(_vm.ProjectDetail.plating))
          ])
        ]),
        _c("div", { staticClass: "columns" }, [
          _c("label", { staticClass: "column is-3" }, [_vm._v("Quantity : ")]),
          _c("div", { staticClass: "column is-9" }, [
            _vm._v(_vm._s(_vm.ProjectDetail.quantity))
          ])
        ]),
        _c("div", { staticClass: "columns" }, [
          _c("label", { staticClass: "column is-3" }, [
            _vm._v("Data Inspection : ")
          ]),
          _c("div", { staticClass: "column is-9" }, [
            _vm._v(_vm._s(_vm.ProjectDetail.dataInspection))
          ])
        ]),
        _c("div", { staticClass: "columns" }, [
          _c("label", { staticClass: "column is-3" }, [
            _vm._v("Engineer Service On Site : ")
          ]),
          _c("div", { staticClass: "column is-9" }, [
            _vm._v(_vm._s(_vm.ProjectDetail.engineerService))
          ])
        ]),
        _c("div", { staticClass: "columns" }, [
          _c("label", { staticClass: "column is-3" }, [
            _vm._v("Description : ")
          ]),
          _c("div", { staticClass: "column breakword is-9" }, [
            _vm._v(_vm._s(_vm.ProjectDetail.detail))
          ])
        ]),
        _c("div", { staticClass: "columns" }, [
          _c("label", { staticClass: "column is-3" }, [_vm._v("Job No. : ")]),
          _c("div", { staticClass: "column  is-9" }, [
            _vm._v(_vm._s(_vm.ProjectDetail.jobNumber))
          ])
        ]),
        _c("div", { staticClass: "columns" }, [
          _c("label", { staticClass: "column is-3" }, [
            _vm._v("Invoice No. : ")
          ]),
          _c("div", { staticClass: "column is-9" }, [
            _vm._v(_vm._s(_vm.ProjectDetail.invoiceNo))
          ])
        ]),
        _c("div", { staticClass: "columns" }, [
          _c("label", { staticClass: "column is-3" }, [
            _vm._v("Invoice Date : ")
          ]),
          _c("div", { staticClass: "column is-9" }, [
            _vm._v(_vm._s(_vm._f("Date")(_vm.ProjectDetail.invoiceDate)))
          ])
        ]),
        _c("div", { staticClass: "columns" }, [
          _c("label", { staticClass: "column is-3" }, [
            _vm._v("Remind Date : ")
          ]),
          _c("div", { staticClass: "column is-9" }, [
            _vm._v(_vm._s(_vm._f("Date")(_vm.ProjectDetail.remindDate)))
          ])
        ]),
        _vm.ProjectDetail.projectStatus === "Delete"
          ? _c("div", { staticClass: "columns" }, [
              _c("label", { staticClass: "column is-3" }, [
                _vm._v("Reject Remerk : ")
              ]),
              _c("div", { staticClass: "column is-9" }, [
                _vm._v(_vm._s(_vm.ProjectDetail.projectRemark))
              ])
            ])
          : _vm._e(),
        _c("div", { staticClass: "columns" }, [
          _c("label", { staticClass: "column is-3" }, [_vm._v("Create On : ")]),
          _c("div", { staticClass: "column is-9" }, [
            _vm._v(_vm._s(_vm._f("DateTime")(_vm.ProjectDetail.createOn)))
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "columns" }, [
      _c("div", { staticClass: "column is-12" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-54dedd00", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54dedd00","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/project-detail.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-54dedd00","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/project-detail.vue
// module chunks = 0